import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import FlowCommentCount from './FlowCommentCount';

const FlowCommentCountBridge = react2angular(FlowCommentCount, [
  'commentCount'
]);

export default FlowCommentCountBridge;
